/* eslint-disable */
export default {
  en: 'Anglais',
  ja: 'Japonais',
  fr: 'Français',
  de: 'Allemand',
  es: 'Espagnol',
  it: 'Italien',
  pt: 'Portugais',
  zh: 'Chinois',
  nl: 'Néerlandais',
  ko: 'Coréen',
  fi: 'Finlandais',
} as const;

// @key: @#@"en"@#@ @source: @#@"English"@#@
// @key: @#@"ja"@#@ @source: @#@"Japanese"@#@
// @key: @#@"fr"@#@ @source: @#@"French"@#@
// @key: @#@"de"@#@ @source: @#@"Deutsch"@#@
// @key: @#@"es"@#@ @source: @#@"Spanish"@#@
// @key: @#@"it"@#@ @source: @#@"Italian"@#@
// @key: @#@"pt"@#@ @source: @#@"Portuguese"@#@
// @key: @#@"zh"@#@ @source: @#@"Chinese"@#@
// @key: @#@"nl"@#@ @source: @#@"Dutch"@#@
// @key: @#@"ko"@#@ @source: @#@"Korean"@#@
// @key: @#@"fi"@#@ @source: @#@"Suomi"@#@
